import { render, staticRenderFns } from "./bscClueManage.vue?vue&type=template&id=2d3e9b55&scoped=true"
import script from "./bscClueManage.vue?vue&type=script&lang=js"
export * from "./bscClueManage.vue?vue&type=script&lang=js"
import style0 from "./bscClueManage.vue?vue&type=style&index=0&id=2d3e9b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e9b55",
  null
  
)

export default component.exports